import Reports_PortfolioBalancerReportPage from "@Reports/Reports/Pages/PortfolioBalancerReportPage.vue";
import Reports_ReportsPage from "@Reports/Reports/Pages/ReportsPage.vue";

export const routes = [
    {
        path: "/pp/reports/:workspaceId/:projectId",
        component: Reports_ReportsPage,
    },
    {
        path: "/reportview/pb/:workspaceId/:projectId/:reportId",
        component: Reports_PortfolioBalancerReportPage,
    },
]
